const inventoryEn = {
    stock: require('lang/en/inventory/Stock').default,
};

export default inventoryEn;